import { ChevronDownIcon } from "@chakra-ui/icons";
import { Box, Divider, Flex, Select, Spinner, Text } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import { useEffect, useMemo, useState } from "react";
import appStore from "../../store";

const AddressInputContent = ({ cityUnion, cityUnionData = {} }) => {
  const { t } = useTranslation("common");
  const {
    deliveryZones,
    tempSelectedCity,
    tempSelectedZone,
    tempSelectedStation,
    isAirport,
  } = appStore;
  const [filterCityUnion, setFilterCityUnion] = useState({});

  useEffect(() => {
    if (cityUnion && Object.keys(cityUnion).length) {
      if (cityUnionData && Object.keys(cityUnionData).length) {
        setFilterCityUnion(cityUnionData);
      } else {
        setFilterCityUnion(cityUnion);
      }
    }
  }, [cityUnion, cityUnionData]);

  const handleChange = (value, label) => {
    appStore[label] = value;
  };

  const level1 = useMemo(() => {
    if (Object.keys(filterCityUnion).length) {
      let cities = Object.keys(filterCityUnion);
      return cities;
    }
    return [];
  }, [filterCityUnion]);

  const level2 = useMemo(() => {
    if (Object.keys(filterCityUnion).length) {
      let zones = [];
      if (tempSelectedCity != "") {
        Object.keys(filterCityUnion[tempSelectedCity]).map((item) => {
          if (item !== "null") {
            if (zones[0]) {
              zones.push(item);
            } else {
              zones[0] = item;
            }
          }
        });
      }
      return zones;
    }
    return [];
  }, [filterCityUnion, tempSelectedCity]);

  const level3 = useMemo(() => {
    if (Object.keys(filterCityUnion).length && tempSelectedCity != "") {
      let stations = [];
      if (tempSelectedZone !== "" && tempSelectedZone !== null) {
        if (level2.length != 0) {
          filterCityUnion[tempSelectedCity][tempSelectedZone].map((item) => {
            if (stations[0]) {
              stations.push(item);
            } else {
              stations[0] = item;
            }
          });
        }
      } else {
        if (level2.length === 0) {
          filterCityUnion[tempSelectedCity]["null"].map((item) => {
            if (stations[0]) {
              stations.push(item);
            } else {
              stations[0] = item;
            }
          });
        }
      }

      if (stations.length === 1 && stations[0].price === null) {
        const deliveryZone = deliveryZones.find(
          (item) =>
            item.level_1 === tempSelectedCity &&
            item.level_2 === tempSelectedZone
        );
        handleChange(deliveryZone?.id, "tempSelectedZoneId");
      }

      return stations;
    }
    return [];
  }, [filterCityUnion, level2.length, tempSelectedCity, tempSelectedZone]);

  return (
    <Box align="start">
      <Box
        onClick={() => {
          handleChange(0, "isAirport");
        }}
      >
        <Box
          opacity={isAirport === 0 ? "1" : "0.4"}
          pointerEvents={isAirport === 0 ? "inherit" : "none"}
        >
          <Text
            mb="8px"
            fontSize="16px"
            fontWeight="500"
            color="rgba(51, 51, 51, 1)"
            lineHeight="23px"
          >
            {t("city")}
          </Text>
          <Select
            isDisabled={level1.length === 0 ? true : false}
            icon={level1.length === 0 ? <Spinner /> : <ChevronDownIcon />}
            value={tempSelectedCity}
            onChange={(e) => {
              handleChange(e.target.value, "tempSelectedCity");
              handleChange("", "tempSelectedZone");
              handleChange("", "tempSelectedStation");
              handleChange(null, "tempSelectedZoneId");
            }}
          >
            <option value="">{t("choose")}</option>
            {level1.map((item) => {
              return (
                <option key={item} value={item}>
                  {t(`city_i18n.${item}`, {
                    defaultValue: item,
                  })}
                </option>
              );
            })}
          </Select>
          {(level2.length !== 0 || tempSelectedCity == "") && (
            <>
              <Text
                mt="16px"
                mb="8px"
                fontSize="16px"
                fontWeight="500"
                color="rgba(51, 51, 51, 1)"
                lineHeight="23px"
              >
                {t("zone")}
              </Text>
              <Select
                isDisabled={
                  tempSelectedCity !== "" && level2.length === 0 ? true : false
                }
                icon={
                  tempSelectedCity != "" && level2.length === 0 ? (
                    <Spinner />
                  ) : (
                    <ChevronDownIcon />
                  )
                }
                value={tempSelectedZone}
                onChange={(e) => {
                  handleChange(e.target.value, "tempSelectedZone");
                  handleChange("", "tempSelectedStation");
                  handleChange(null, "tempSelectedZoneId");
                }}
              >
                <option value="">{t("choose")}</option>
                {level2.map((item) => {
                  return (
                    <option key={item} value={item}>
                      {t(`zone_i18n.${item}`, {
                        defaultValue: item,
                      })}
                    </option>
                  );
                })}
              </Select>
            </>
          )}
        </Box>
      </Box>
      <Flex mt="16px" alignItems="center">
        <Divider />
        <Text
          px="40px"
          color="rgba(136, 136, 136, 1)"
          fontSize="16px"
          fontWeight="500"
          lineHeight="23px"
        >
          or
        </Text>
        <Divider />
      </Flex>
      <Box mb="24px">
        <Text
          mt="16px"
          mb="8px"
          fontSize="16px"
          fontWeight="500"
          color="rgba(51, 51, 51, 1)"
          lineHeight="23px"
        >
          {t("Airport")}
        </Text>
        <Flex>
          <Text
            px="16px"
            py="10px"
            border="1px solid rgba(51, 51, 51, 1)"
            borderRadius="8px"
            mr="16px"
            fontWeight="500"
            fontSize="14px"
            lineHeight="20px"
            bg={isAirport === 1 ? "#333333" : "white"}
            color={isAirport === 1 ? "white" : "rgba(51, 51, 51, 1)"}
            cursor="pointer"
            onClick={() => {
              handleChange(1, "isAirport");
            }}
          >
            {t("station_i18n.機場第一航廈")}
          </Text>
          <Text
            px="16px"
            py="10px"
            border="1px solid rgba(51, 51, 51, 1)"
            borderRadius="8px"
            fontWeight="500"
            fontSize="14px"
            lineHeight="20px"
            bg={isAirport === 2 ? "#333333" : "white"}
            color={isAirport === 2 ? "white" : "rgba(51, 51, 51, 1)"}
            cursor="pointer"
            onClick={() => {
              handleChange(2, "isAirport");
            }}
          >
            {t("station_i18n.機場第二航廈")}
          </Text>
        </Flex>
      </Box>
    </Box>
  );
};
export default AddressInputContent;
